export const iconLevels = {
    warning: "error_outline",
    error:   "report_problem",
}
